// extracted by mini-css-extract-plugin
export var label = "_3p-1";
export var reminder = "_3p-0";